
<script setup>
import { ref, onMounted, computed, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

const nValid1 = ref(0);
const nValid2 = ref(0);
const resultHuman = ref('');
const resultvalid = ref(0);

const validNumber = () => {
    nValid1.value = Math.ceil(Math.random() * 10);
    nValid2.value = Math.ceil(Math.random() * 10);
    resultvalid.value = parseInt(nValid1.value) + parseInt(nValid2.value);
};

onMounted(() => {
    validNumber();
});

const isValid = computed(() => {
    return resultHuman.value !== '' && resultHuman.value === resultvalid.value;
});

watch(isValid, (newValue) => {
    emit('update:modelValue', newValue);
});
</script>

<template>
    <div class="xl:w-[400px] sm:w-[370px] w-full flex justify-between gap-4 p-3 sm:p-4 rounded-md items-center space-x-3 border-2 transition-all duration-300 ease-in-out bg-cover bg-center" :class="{
        'bg-green-50 border-green-600 bg-[url(/img/captcha-2.svg)]': resultHuman !== '' && isValid,
        'bg-red-50 border-red-500 bg-[url(/img/captcha-3.svg)]': resultHuman !== '' && !isValid,
        'border-gray-400 hover:border-gray-600 bg-white bg-[url(/img/captcha-1.svg)]': resultHuman === ''
    }">
        <div class="text-xs font-extrabold"><span style="text-shadow: -2px 0 #ffffff, 0 2px #ffffff, 2px 0 #ffffff, 0 -2px #ffffff">
            <template v-if="resultHuman === ''">Por su seguridad<br>resuelva esta operación.</template>
            <template v-else-if="isValid">¡Excelente!<br>La respuesta es correcta.</template>
            <template v-else>La respuesta que indica<br>es incorrecta.</template>
        </span></div>
        <div class="flex flex-row items-center text-lg lg:text-2xl xl:text-3xl">
            <div class="font-['Rubik_Dirt']">{{ nValid1 }} + {{ nValid2 }} =</div>
            <input type="text" v-model.number="resultHuman" class="w-12 ml-2 focus:ring-0 text-center" required>
        </div>
    </div>
</template>

<!--
========================================================================
DOCUMENTACIÓN DE USO: MathCaptcha
========================================================================
Este componente es un Captcha Matemático reutilizable para evitar SPAM.
Devuelve un valor booleano (true/false) mediante `v-model` indicando si 
la respuesta matemática ingresada por el usuario es correcta.

¿Cómo implementarlo en cualquier otro formulario (Vue 3)?

1. Importar el componente en tu <script setup>:
   import MathCaptcha from '@/Components/MathCaptcha.vue';
   import { ref } from 'vue';

2. Crear una variable reactiva para saber si es válido:
   const isCaptchaValid = ref(false);

3. Colocar el componente en tu <template> vinculando esa variable:
   <MathCaptcha v-model="isCaptchaValid" />

4. Deshabilitar tu botón de "Enviar" o "Guardar" si el captcha no es válido:
   <button type="submit" :disabled="!isCaptchaValid">
       Enviar
   </button>

Nota: Las imágenes SVG de fondo, los colores de validación y la lógica
están encapsulados. No requieres configurar nada más en el padre.
========================================================================
-->
